import { Button, CircularProgress, Divider, Modal, Table, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { useRef, useEffect, useState } from 'react';
import BrandFilter from '../comp/brandfilter';
import Companydown from '../comp/companydown';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import '../css/modal.css'

const ProductBonusClear = ({ handleClose, token, open, custrow, handleModal, handleRefresh }) => {

    const [prodload, setProdload] = useState(false);
    const [isOpen, setisOpen] = useState(false);
    const [pcompid, setCompany] = useState("");
    const pcode = useRef();

    const handleEscape = (e) => {
        if (e.keyCode == 27) {
            handleClose(false);
        }

    }

    const handleClickOpen = () => {
        setisOpen(true);
      };
    
      const handleClickClose = () => {
        setisOpen(false);
      };

    useEffect(() => {
        window.addEventListener('keyup', handleEscape);
        return () => {
            window.removeEventListener('keyup', handleEscape);
        }
    }, [])


    const handleClick = () => {
        handleClick(false);
    }

    const handleSubmit = () => {
        setProdload(true);
        if(pcompid == "")
        {
            alert("Компани сонгоогүй байна.");
            setProdload(false);
        }
        else
        {
            var req = {
                'com_id': pcompid,
            }

            const request = new Request('https://wms-cloud.com/api/ClearAllBonus', {
                method: 'POST',
                body: JSON.stringify(req),
                headers: new Headers({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': `Bearer ${token}` })
            });

            fetch(request).then((response) => {
                if (response.status === 200) {
                    return response.json();

                } else {
                    console.log("aldaa garsan" + response.status);
                    alert("Ажилтгүй дахин оролдоно уу. " + JSON.stringify(response));
                    setProdload(false);
                }
            }).then((resp) => {
                alert(resp.id +" барааны урамшуулал "+resp.status+" устгагдлаа");
                setProdload(false);
                handleClose(false);
                handleRefresh();
            });
        }


    }
    return <div className="custmodal" >
        <div className="mcont">
            <div className="mheader">
                Сонгосон компани бүх барааны урамшуулалыг устгах хэсэг
            <button aria-label="Хаах" onClick={() => handleClose()}>✕</button>
            </div>
            <Divider />
            <div className="mccont">
                <div className="crow">
                    <div style={{ width: "", paddingRight: "10px" }}>
                        <Companydown token={token} handleComp={setCompany} />
                    </div>
                </div>
            </div>
            <div className="mfooter">
                <Button onClick={() => handleClose()}>Буцах</Button>
                <Button variant="contained" onClick={setisOpen}>Хадгалах</Button>
                {/* <button>Save</button> */}
                {/* <button>Cancel</button> */}
            </div>
            {prodload ?
                <div className="prodload">
                    <CircularProgress />
                </div> : ""}
        </div>
        <Dialog
        open={isOpen}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Тухайн компани дээрх бүх барааны урамшууллыг устгахдаа итгэлтэй байна уу?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Тухайн компани дээрх бүх барааны урамшуулал хувь болон урамшуулал тоо ширхэг бүгд 0 болох ба дахин сэргээгдэх боломжгүй гэдгийг анхаарна уу
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickClose}>Татгалзах</Button>
          <Button onClick={handleSubmit} autoFocus>
            Зөвшөөрөх
          </Button>
        </DialogActions>
      </Dialog>
    </div >
}

export default ProductBonusClear;